import React from 'react';
import { useApp } from '../context/AppContext';
import { Link } from 'react-router-dom';
import { ShoppingCart, Plus, Trash2 } from 'lucide-react';

const FavoritesPage: React.FC = () => {
  const { favorites, toggleFavorite, getAllProducts, addToCart } = useApp();
  const allProducts = getAllProducts();
  const favoriteProducts = favorites
    .map(id => allProducts.find(p => p.id === id))
    .filter(Boolean);

  return (
    <div className="container mx-auto px-6 py-12 animate-fade-in bg-[#fcfcfc] min-h-[70vh]">
      <h1 className="text-4xl font-serif text-gray-900 mb-2 border-b border-gray-100 pb-4">Moje Ulubione</h1>
      
      {favoriteProducts.length === 0 ? (
        <div className="text-center py-24 text-gray-500">
           <p className="text-xl font-light mb-4 text-gray-400">Nie masz jeszcze żadnych zapisanych produktów.</p>
           <Link to="/" className="inline-block mt-4 bg-black text-white px-8 py-3 rounded-sm font-bold text-xs uppercase tracking-widest hover:bg-gray-800 transition-colors">
              Przejdź do sklepu
           </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12 mt-8">
            {favoriteProducts.map((item: any) => {
                const productLink = `/product/${item.id}`;
                return (
                  <div key={item.id} className="group flex flex-col relative animate-fade-in">
                      {/* Image Area */}
                      <div className="relative">
                          <Link to={productLink} className="block aspect-[4/5] bg-[#f5f5f5] mb-4 overflow-hidden relative cursor-pointer">
                              <img 
                                  src={item.imageUrl}
                                  alt={item.title}
                                  className="w-full h-full object-cover mix-blend-multiply group-hover:scale-105 transition-transform duration-700 ease-in-out"
                              />
                              <div className="absolute bottom-0 left-0 w-full bg-white/90 py-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300 flex justify-center items-center opacity-0 group-hover:opacity-100 z-20">
                                  <button 
                                      onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          addToCart({
                                              id: `${item.id}`,
                                              productId: item.id || '',
                                              title: item.title,
                                              price: parseFloat(item.price || '0'),
                                              imageUrl: item.imageUrl || '',
                                              quantity: 1,
                                              shippingSize: item.shippingSize || 'parcel_locker'
                                          })
                                      }}
                                      className="uppercase tracking-widest text-[10px] font-bold text-black hover:text-gray-600 flex items-center gap-2"
                                  >
                                      <Plus size={12}/> Do koszyka
                                  </button>
                              </div>
                          </Link>
                          
                          {/* Remove from favorites */}
                          <button 
                              onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleFavorite(item.id); }}
                              className="absolute top-4 right-4 z-20 p-2 rounded-full transition-all duration-300 bg-white text-red-500 hover:bg-red-50 shadow-sm"
                              title="Usuń z ulubionych"
                          >
                             <Trash2 size={16} />
                          </button>
                      </div>

                      {/* Content Area */}
                      <div className="text-left">
                          <Link to={productLink} className="block">
                              <h3 className="font-serif text-base text-gray-900 mb-1 leading-snug group-hover:underline decoration-1 underline-offset-4">{item.title}</h3>
                              <p className="text-[10px] text-gray-400 mb-2 uppercase tracking-wide truncate">{item.description}</p>
                              <div className="flex justify-start gap-3 items-baseline">
                                  {item.oldPrice && <span className="text-xs text-gray-400 line-through">{item.oldPrice} PLN</span>}
                                  <span className="text-sm font-bold text-black">{item.price} PLN</span>
                              </div>
                          </Link>
                      </div>
                  </div>
                );
            })}
        </div>
      )}
    </div>
  );
};

export default FavoritesPage;
